export const languages = ['he', 'en']
export const fileTypes = ['pdf', 'thumbnail']
